import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define the initial state for the slice
interface IExportState {
    exportTabsValues: any;
    selectedExport:boolean;
    exportId:string;
    exportName:string;
    selectedExportId:string | null;
    selectedFields:any;
}

const initialState: IExportState = {
    exportTabsValues: {},
    selectedExport:false,
    exportId: '',
    exportName:'',
    selectedExportId:'',
    selectedFields:[]
};

const addExportSlice = createSlice({
  name: 'export',
  initialState,
  reducers: {
    setExportTab1Params(state, action: PayloadAction<any>) {
        state.exportTabsValues = action.payload;
    },
    setSelectedExport(state, action: PayloadAction<boolean>) {
        state.selectedExport = action.payload;
    },
    setSelectedExportId(state, action: PayloadAction<string>) {
      state.selectedExportId = action.payload;
    },
    setExportId(state, action: PayloadAction<string>) {
        state.exportId = action.payload;
    },
    setExportName(state, action: PayloadAction<string>) {
        state.exportName = action.payload;
    },
    setSelectedFieldsData(state, action: PayloadAction<any>) {
      state.selectedFields = action.payload;
    }
  },
});

export const { setExportTab1Params, setSelectedExport,setExportId,setExportName, setSelectedExportId, setSelectedFieldsData } = addExportSlice.actions;

export default addExportSlice.reducer;
